<template>
  <div class="salesOrder">
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="420px"
        top="30vh">
      <div style="display: flex; flex-direction: row; align-items: center">
        <i class="el-icon-warning" style="font-size: 24px; color: #e6a23c"/>
        <span style="margin-left: 10px">确定提交吗？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-loading="submitLoading" type="primary" @click="oneSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        salesOrderId: "",
      };
    },

    methods: {
      open(id) {
        this.salesOrderId = id;
        this.dialogVisible = true;
      },

      //提交
      oneSubmit() {
        this.submitLoading = true;
        this.$http.post("basic", `sd/so/submit/${this.salesOrderId}`).then((res) => {
          if (res.success) {
            this.$message.success("提交成功");
            this.$emit("save-success");
          }
          this.dialogVisible = false;
          this.submitLoading = false;
        }).catch(() => {
          this.dialogVisible = false;
          this.submitLoading = false;
        });
      },
    },
  };
</script>

<style lang="scss">
.salesOrder {
  .productTable {
    .el-input__inner {
      text-align: center;
    }
  }
}
</style>
